import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_video_start",
  "use": "icon-icon_video_start-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_video_start\">\n<path d=\"M19.25 11.567C19.5833 11.7594 19.5833 12.2406 19.25 12.433L8.75 18.4952C8.41667 18.6876 8 18.4471 8 18.0622L8 5.93782C8 5.55292 8.41667 5.31236 8.75 5.50481L19.25 11.567Z\" fill=\"white\" stroke=\"white\" stroke-width=\"1.5\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol